import { Helmet } from "react-helmet-async";

interface SEOProps {
    title?: string;
    description?: string;
    canonical?: string;
    ogType?: string;
    ogImage?: string;
    twitterCard?: string;
}

export function SEO({
    title = "Solace SMART Solutions | HVAC, Refrigeration & Electrical Solutions",
    description = "Solace SMART Solutions provides premium HVAC, Refrigeration, Heat Pump, and Electrical engineering solutions with Japanese precision across India.",
    canonical,
    ogType = "website",
    ogImage = "/assets/Solacesmartlogo.webp",
    twitterCard = "summary_large_image",
}: SEOProps) {
    const siteName = "Solace SMART Solutions";
    const fullTitle = title.includes(siteName) ? title : `${title} | ${siteName}`;
    const url = typeof window !== "undefined" ? window.location.href : "";
    const canonicalUrl = canonical || url;

    // Ensure ogImage is absolute
    const absoluteOgImage = ogImage.startsWith("/")
        ? `https://solacesmart.com${ogImage}`
        : ogImage;

    return (
        <Helmet>
            {/* Basic Meta Tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={canonicalUrl} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={ogType} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={absoluteOgImage} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:site_name" content={siteName} />

            {/* Twitter */}
            <meta name="twitter:card" content={twitterCard} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={absoluteOgImage} />

            {/* Additional SEO */}
            <meta name="robots" content="index, follow" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta charSet="UTF-8" />
        </Helmet>
    );
}
